<template>
	<div v-if="phoneList && phoneList.length > 0" class="phone_alarm_set">
		<div class="phone_alarm_set-left" ref="PhoneAlarmSetLeftRef">
			<div class="phone-greeting">{{ getTimeOfDay() }}</div>
			<div class="phone-selector">
				<div class="phone-btn" @click="togglePopup">
					<div class="phone-btn-text">{{ currentPhone }}</div>
					<img class="dropdown-icon" :src="dropdownIcon" :class="{ 'rotate-180': isPopupVisible }" alt="下拉箭头">
				</div>

				<transition name="slide-fade">
					<div v-if="isPopupVisible" class="phone-popup">
						<img class="popup-triangle" :src="triangleIcon" alt="弹窗箭头">
						<ul class="phone-list">
							<li v-for="item in phoneList" :key="item.number" class="phone-item" @click="selectPhone(item)"
								@mouseenter="item.hover = true" @mouseleave="item.hover = false">
								<img class="select-icon" :src="item.isSelected ? selectedIcon : unselectedIcon" alt="选中状态">
								<div class="phone-list-li-number" :style="{ color: item.isSelected ? 'rgba(23, 143, 254, 1)' : 'rgba(88, 89, 90, 1)' }">{{ item.phone }}</div>
							</li>
						</ul>
					</div>
				</transition>
			</div>
		</div>
		<div class="phone_alarm_set-right" ref="PhoneAlarmSetRightRef">
			<div class="status-selector">
				<div class="status-btn" :style="{ border: currentStatus == 1 ? '1px solid rgba(24, 144, 255, 0.3)' : '1px solid rgba(255, 77, 79, 0.3)' }" @click="togglePopupStatus">
					<img class="status_icon" :src="currentStatus == 1 ? phoneAbleIcon : phoneDisabledIcon" alt="下拉箭头">
					<div class="status-btn-text" :style="{ color: currentStatus == 1 ? 'rgba(24, 144, 255, 1)' : 'rgba(255, 77, 79, 1)' }">{{ currentStatusDesc }}</div>
					<img class="dropdown-icon" :src="dropdownIcon" :class="{ 'rotate-180': statusIsPopupVisible }" alt="下拉箭头">
				</div>

				<transition name="slide-fade">
					<div v-if="statusIsPopupVisible" class="status-popup">
						<img class="popup-triangle" :src="triangleIcon" alt="">
						<ul class="status-list">
							<li v-for="item in statusList" :key="item.number" class="status-item" @click="selectStatus(item)"
								@mouseenter="item.hover = true" @mouseleave="item.hover = false">
								<img class="select-icon" :src="item.isSelected ? selectedIcon : unselectedIcon" alt="选中状态">
								<div class="status-list-li-number" :style="{ color: item.isSelected ? 'rgba(23, 143, 254, 1)' : 'rgba(88, 89, 90, 1)' }">{{ item.desc }}</div>
							</li>
						</ul>
					</div>
				</transition>
			</div>
		</div>

		<el-dialog
			custom-class="phone_alarm_set_dialog"
			title=""
			:visible.sync="dialogVisible"
			width="400px"
			:modal-append-to-body="false"
			>
			<div class="dialog_container">
				<img class="dialog_container-img" :src="tipType === 1 ? require('@/assets/icon_protect_home_phone_alarm_8.png') : require('@/assets/icon_protect_home_phone_alarm_9.png')" alt="">
				<div class="dialog_container-text">{{ tipDesc }}</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<div class="sure_btn_container">
					<div class="sure_btn" @click="dialogVisible = false">知道了</div>
				</div>
			</span>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'PhoneSelector',
	data() {
		return {
			isPopupVisible: false,
			phoneList: null,
			triangleIcon: require('@/assets/icon_protect_home_phone_alarm_7.png'),
			selectedIcon: require('@/assets/icon_protect_home_phone_alarm_1.png'),
			unselectedIcon: require('@/assets/icon_protect_home_phone_alarm_2.png'),
			currentPhone: '',
			currentPhoneId: '',

			statusIsPopupVisible: false,
			statusList: [],
			phoneAbleIcon: require('@/assets/icon_protect_home_phone_alarm_5.png'),
			phoneDisabledIcon: require('@/assets/icon_protect_home_phone_alarm_6.png'),
			currentStatus: 1,
			currentStatusDesc: '可接听报警',

			dialogVisible: false,
			tipDesc: '',
			tipType: 0
		}
	},
	computed: {
		dropdownIcon() {
			return require('@/assets/icon_protect_home_phone_alarm_3.png');
		}
	},
	mounted() {
		this.getPhoneAlarmData();
		document.addEventListener('click', this.handleClickOutside);
	},
	beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
	methods: {

		// 获取电话报警列表
		getPhoneAlarmData() {
			this.$get(
				'/api/nurse/getAlarmPhones',
				'',
				(res) => {
					if (res && res.code == 0) {
						if (res.data && res.data.length > 0) {
							this.statusList = [
								{ desc: '不接听报警', isSelected: false, hover: false, type: 0 },
								{ desc: '可接听报警', isSelected: false, hover: false, type: 1 }
							];
							let tempArr = JSON.parse(JSON.stringify(res.data));
							tempArr.forEach((item, index) => {
								if (index === 0) {
									item.isSelected = true;
									this.currentPhoneId = item.id;
									this.currentPhone = item.phone;
									this.currentStatus = item.phoneEnable === 0 ? 1 : 0;
									this.currentStatusDesc = item.phoneEnable === 0 ? '可接听报警' : '不接听报警';
									this.statusList[0].isSelected = item.phoneEnable !== 0 ? true : false;
									this.statusList[1].isSelected = item.phoneEnable === 0 ? true : false;
								} else {
									item.isSelected = false;
								}
								item.hover = false;
							});
							this.phoneList = tempArr;
						} else {
							this.phoneList = [];
						}
					} else {
						this.phoneList = [];
						this.$message.error(res.msg);
					}
				},
				(err) => {
					this.$message.error('服务端发生异常');
				}
			);
		},

		// 切换电话报警状态
		setPhoneAlarmStatus(item, callback) {
			let params = {
				phoneEnable: item.type == 1 ? 0 : 1,
				userPhoneId: this.currentPhoneId,
			}
			this.$get(
				'/api/nurse/updateAlarmPhoneStatus',
				params,
				(res) => {
					if (res && res.code == 0) {
						if (callback) callback(true);
						this.getPhoneAlarmData();
					} else {
						if (callback) callback(false);
						this.$message.error(res.msg);
					}
				},
				(err) => {
					if (callback) callback(false);
					this.$message.error('服务端发生异常');
				}
			);
		},

		// 切换电话报警手机号
		setPhoneAlarmMobile(item, callback) {
			let params = {
				userPhoneId: item.id,
			}
			this.$get(
				'/api/nurse/switchUserPhone',
				params,
				(res) => {
					if (res && res.code == 0) {
						if (callback) callback(true);
						this.getPhoneAlarmData();
					} else {
						if (callback) callback(false);
						this.$message.error(res.msg);
					}
				},
				(err) => {
					if (callback) callback(false);
					this.$message.error('服务端发生异常');
				}
			);
		},

		togglePopup() {
			this.isPopupVisible = !this.isPopupVisible;
		},
		selectPhone(item) {
			this.setPhoneAlarmMobile(item, (isSuccess) => {
				if (isSuccess) {
					this.togglePopup();
				}
			});
		},
		// 获取 早上好｜下午好｜晚上好
		getTimeOfDay() {
			const now = new Date();
			const hours = now.getHours();
			if (hours >= 6 && hours < 12) return '早上好，';
			else if (hours >= 12 && hours < 17) return '下午好，';
			else return '晚上好，';
		},


		togglePopupStatus() {
			this.statusIsPopupVisible = !this.statusIsPopupVisible;
		},
		selectStatus(item) {
			let tempItem = JSON.parse(JSON.stringify(item));
			this.setPhoneAlarmStatus(item, (isSuccess) => {
				if (isSuccess) {
					this.togglePopupStatus();
					this.dialogVisible = true;
					this.tipType = tempItem.type;
					this.tipDesc = this.$store.state.user_info.name + ' ' + this.currentPhone + ' ' + '切换为“' + (tempItem.type == 1 ? '可接听报警' : '不接听报警') + (tempItem.type == 1 ? '”状态。从现在开始，报警电话会直接拨打给你' : '”状态。工作辛苦了，从现在开始报警电话不会再拨打给你');
				}
			});
		},

    handleClickOutside(event) {
			if (this.$refs.PhoneAlarmSetLeftRef) {
				const phoneAlarmSetLeftRef = this.$refs.PhoneAlarmSetLeftRef;
				const isClickOutside = this.isPopupVisible && !(phoneAlarmSetLeftRef.contains(event.target));
				if (isClickOutside) {
					this.isPopupVisible = false;
				}
			}
			if (this.$refs.PhoneAlarmSetRightRef) {
				const phoneAlarmSetRightRef = this.$refs.PhoneAlarmSetRightRef;
				const isClickOutside = this.statusIsPopupVisible && !(phoneAlarmSetRightRef.contains(event.target));
				if (isClickOutside) {
					this.statusIsPopupVisible = false;
				}
			}
    },
	}
}
</script>

<style scoped lang="scss">
.phone_alarm_set {
	display: flex;
	align-items: center;

	.phone_alarm_set-right {
		display: flex;
		align-items: center;
		margin-left: 10px;
		
		.status-greeting {
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 14px;
			color: #262626;
			line-height: 20px;
		}

		.status-selector {
			position: relative;
			display: inline-block;

			.status_icon {
				width: 20px;
				height: 20px;
				margin-right: 5px;
			}

			.status-btn {
				display: flex;
				align-items: center;
				cursor: pointer;
				transition: background-color 0.3s;
				padding: 5px 10px;
				border-radius: 16px;
				border: 1px solid #1890FF;

				.status-btn-text {
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 14px;
					color: #262626;
					line-height: 20px;
					margin-right: 5px;
				}

				.status-btn-text:hover {
					color: rgba(24, 144, 255, 1);
				}

				.dropdown-icon {
					width: 16px;
					height: 16px;
					transition: all 0.3s ease;
					transform-origin: center center;
				}

				.rotate-180 {
					transform: rotate(180deg);
				}
			}

			.status-popup {
				position: absolute;
				top: 100%;
				left: 6px;
				margin-top: 8px;
				background-color: #fff;
				border: 1px solid rgba(183, 220, 254, 1);
				border-radius: 4px;
				box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
				z-index: 10;

				.popup-triangle {
					position: absolute;
					top: -8px;
					left: 50%;
					transform: translateX(-50%);
					width: 13px;
					height: 8px;
				}

				.status-list {
					list-style: none;
					padding: 0;
					margin: 0;
					padding-top: 5px;
					padding-bottom: 5px;

					.status-item {
						padding: 8px 10px;
						cursor: pointer;
						display: flex;
						align-items: center;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 14px;
						color: #58595A;
						line-height: 20px;
						margin-left: 5px;
						margin-right: 5px;
						border-radius: 2px;

						&:hover,
						&.hover {
							background-color: rgba(23, 143, 254, 0.1);
						}

						.select-icon {
							width: 16px;
							height: 16px;
							margin-right: 8px;
						}
					}

					.status-list-li-number {
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 14px;
						color: #58595A;
						line-height: 20px;
					}
				}
			}

			.slide-fade-enter-active {
				animation: slideFadeIn 0.3s ease;
			}

			.slide-fade-leave-active {
				animation: slideFadeOut 0.3s ease;
			}

			@keyframes slideFadeIn {
				from {
					opacity: 0;
					transform: translateY(-10px);
				}

				to {
					opacity: 1;
					transform: translateY(0);
				}
			}

			@keyframes slideFadeOut {
				from {
					opacity: 1;
					transform: translateY(0);
				}

				to {
					opacity: 0;
					transform: translateY(-10px);
				}
			}
		}
	}

	.phone_alarm_set-left {
		display: flex;
		align-items: center;
		.phone-greeting {
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 14px;
			color: #262626;
			line-height: 20px;
		}

		.phone-selector {
			position: relative;
			display: inline-block;

			.phone-btn {
				display: flex;
				align-items: center;
				cursor: pointer;
				transition: background-color 0.3s;

				.phone-btn-text {
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 14px;
					color: #262626;
					line-height: 20px;
				}

				.phone-btn-text:hover {
					color: rgba(24, 144, 255, 1);
				}

				.dropdown-icon {
					width: 16px;
					height: 16px;
					margin-left: 4px;
					transition: all 0.3s ease;
					transform-origin: center center;
				}

				.rotate-180 {
					transform: rotate(180deg);
				}
			}

			.phone-popup {
				position: absolute;
				top: 100%;
				left: -20px;
				margin-top: 8px;
				background-color: #fff;
				border: 1px solid rgba(183, 220, 254, 1);
				border-radius: 4px;
				box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
				z-index: 10;

				.popup-triangle {
					position: absolute;
					top: -8px;
					left: 50%;
					transform: translateX(-50%);
					width: 13px;
					height: 8px;
				}

				.phone-list {
					list-style: none;
					padding: 0;
					margin: 0;
					padding-top: 5px;
					padding-bottom: 5px;

					.phone-item {
						padding: 8px 10px;
						cursor: pointer;
						display: flex;
						align-items: center;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 14px;
						color: #58595A;
						line-height: 20px;
						margin-left: 5px;
						margin-right: 5px;
						border-radius: 2px;

						&:hover,
						&.hover {
							background-color: rgba(23, 143, 254, 0.1);
						}

						.select-icon {
							width: 16px;
							height: 16px;
							margin-right: 8px;
						}
					}

					.phone-list-li-number {
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 14px;
						color: #58595A;
						line-height: 20px;
						white-space: nowrap;
					}
				}
			}

			.slide-fade-enter-active {
				animation: slideFadeIn 0.3s ease;
			}

			.slide-fade-leave-active {
				animation: slideFadeOut 0.3s ease;
			}

			@keyframes slideFadeIn {
				from {
					opacity: 0;
					transform: translateY(-10px);
				}

				to {
					opacity: 1;
					transform: translateY(0);
				}
			}

			@keyframes slideFadeOut {
				from {
					opacity: 1;
					transform: translateY(0);
				}

				to {
					opacity: 0;
					transform: translateY(-10px);
				}
			}
		}
	}

}
</style>

<style lang="scss">
.phone_alarm_set_dialog {
	.el-dialog__header {
		padding-top: 0px;
		padding-bottom: 0px;
		height: 30px;
		.el-dialog__headerbtn {
			height: 20px;
			top: 0px;
		}
	}
	.dialog_container {
		display: flex;
		.dialog_container-img {
			width: 16px;
			height: 16px;
			margin-top: 2px;
			margin-right: 10px;
		}
		.dialog_container-text {
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 14px;
			color: #262626 !important;
			line-height: 20px;
		}
	}
	.el-dialog__footer {
		padding-top: 20px;
		padding-bottom: 20px;
		display: flex;
		justify-content: flex-end;
		.sure_btn_container {
			display: flex;
			height: 32px;
			.sure_btn {
				cursor: pointer;
				align-self: flex-end;
				padding: 5px 16px;
				background: #FFFFFF;
				border-radius: 2px;
				border: 1px solid rgba(0,0,0,0.15);
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 14px;
				color: rgba(0,0,0,0.65);
				line-height: 22px;
			}
		}
	}
}
</style>